export class UsersService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        'ngInject';
        this.MessagingHubService = MessagingHubService;
        this.MessagingHubService = MessagingHubService;
    }
    getUser(application, nameOrIdentity) {
        const uri = `/contacts/${encodeURIComponent(nameOrIdentity)}`;
        return this.MessagingHubService.sendCommand({
            method: 'get',
            uri: uri,
        }, 50000);
    }
    getUsers(filters, skip, take) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            uri: `/contacts?$skip=${skip}&$take=${take}${filters}`,
        }, 50000);
    }
    setUser(user) {
        return this.MessagingHubService.sendCommand({
            method: 'set',
            uri: '/contacts',
            resource: user,
            type: 'application/vnd.lime.contact+json',
        });
    }
    mergeUser(user) {
        return this.MessagingHubService.sendCommand({
            method: 'merge',
            uri: '/contacts',
            resource: user,
            type: 'application/vnd.lime.contact+json',
        });
    }
    getDecodedUserIdentity(identity) {
        const decodedIdentityName = decodeURIComponent(identity.split('@')[0]);
        const identityDomain = identity.split('@')[1];
        const id = `${decodedIdentityName}@${identityDomain}`;
        return id;
    }
}
UsersService.$inject = ['MessagingHubService'];
